const UNSUPPORTED_NAME_CHARACTER_PATTERN = /[\p{Cc}\p{Cf}\p{Zl}\p{Zp}]/gu;
const WHITESPACE_RUN_PATTERN = /\s+/gu;

const getCharacterLabel = (character) => {
    const labels = {
        "\t": "制表符（Tab）",
        "\n": "换行符",
        "\r": "回车符",
        "\u200B": "零宽空格",
        "\u200C": "零宽非连接符",
        "\u200D": "零宽连接符",
        "\uFEFF": "零宽不换行空格",
    };
    if (labels[character]) return labels[character];

    const codePoint = character.codePointAt(0).toString(16).toUpperCase().padStart(4, "0");
    return `不可见字符 U+${codePoint}`;
};

export const findUnsupportedScheduleNameCharacters = (value) => {
    if (typeof value !== "string") return [];
    return value.match(UNSUPPORTED_NAME_CHARACTER_PATTERN) || [];
};

export const cleanScheduleName = (value) => {
    if (typeof value !== "string") return "";

    const cleaned = Array.from(value, (character) => {
        if (!findUnsupportedScheduleNameCharacters(character).length) return character;
        return /\s/u.test(character) || /[\p{Zl}\p{Zp}]/u.test(character) ? " " : "";
    }).join("");

    return cleaned.replace(WHITESPACE_RUN_PATTERN, " ").trim();
};

export const inspectScheduleName = (value) => {
    const unsupportedCharacters = findUnsupportedScheduleNameCharacters(value);
    const counts = unsupportedCharacters.reduce((result, character) => {
        const label = getCharacterLabel(character);
        result.set(label, (result.get(label) || 0) + 1);
        return result;
    }, new Map());

    return {
        hasUnsupportedCharacters: unsupportedCharacters.length > 0,
        unsupportedCharacters,
        summary: Array.from(counts, ([label, count]) => `${label} × ${count}`).join("、"),
        cleanedName: cleanScheduleName(value),
    };
};
